






























import { computed, defineComponent, onMounted, PropType } from '@nuxtjs/composition-api';
import { Category } from '~/features/categories';
import { useCategorySlider } from '~/features/categorySlider';

const gradientClasses = ['gradient-primary-700', 'gradient-primary-600', 'gradient-primary-800'];
export default defineComponent({
  name: 'CategorySlider',
  props: {
    category: {
      type: Object as PropType<Category>,
      default: () => {},
    },
    includeParentCategory: {
      type: Boolean,
      default: true,
    },
  },
  setup({ category, includeParentCategory }, { emit }) {
    const { categories, category: selectedCategory } = useCategorySlider();

    const sliderCategories = computed(() => {
      return includeParentCategory ? categories.value : categories.value.slice(1);
    });

    /**
     * on mounted set the selected category component to the one injected
     */
    onMounted(() => {
      /**
       * set the selected category
       */
      selectedCategory.value = category;
    });

    function onSelectCategory(category: Category) {
      if (!(category.url || category.url_key)) {
        return;
      }
      /**
       * set the selected category
       */

      emit('category', `/${category.url || category.url_key}`);
    }

    return {
      sliderCategories,
      onSelectCategory,
      gradientClasses,
    };
  },
});
